<template>
    <div class="dispositivos-mantenimiento">
        <h2>Mantenimiento - Dispositivos Médicos</h2>
        <div class="mantenimiento-content">
            <el-card>
                <div slot="header">
                    <span>Gestión de Mantenimiento de Dispositivos Médicos</span>
                </div>
                <el-table :data="mantenimientos" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="dispositivo" label="Dispositivo"></el-table-column>
                    <el-table-column prop="tipo" label="Tipo de Mantenimiento"></el-table-column>
                    <el-table-column prop="fechaProgramada" label="Fecha Programada"></el-table-column>
                    <el-table-column prop="estado" label="Estado"></el-table-column>
                    <el-table-column prop="responsable" label="Responsable"></el-table-column>
                    <el-table-column label="Acciones" width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="editarMantenimiento(scope.row)">Editar</el-button>
                            <el-button size="mini" type="danger"
                                @click="eliminarMantenimiento(scope.row)">Eliminar</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosMantenimiento',
    data() {
        return {
            mantenimientos: [
                { id: 1, dispositivo: 'Monitor Cardíaco', tipo: 'Preventivo', fechaProgramada: '2024-02-15', estado: 'Programado', responsable: 'Técnico A' },
                { id: 2, dispositivo: 'Ventilador Mecánico', tipo: 'Correctivo', fechaProgramada: '2024-02-10', estado: 'En Proceso', responsable: 'Técnico B' },
                { id: 3, dispositivo: 'Bomba de Infusión', tipo: 'Preventivo', fechaProgramada: '2024-02-20', estado: 'Completado', responsable: 'Técnico C' },
                { id: 4, dispositivo: 'Desfibrilador', tipo: 'Correctivo', fechaProgramada: '2024-02-12', estado: 'Pendiente', responsable: 'Técnico A' }
            ]
        }
    },
    methods: {
        editarMantenimiento(mantenimiento) {
            console.log('Editar mantenimiento:', mantenimiento)
        },
        eliminarMantenimiento(mantenimiento) {
            console.log('Eliminar mantenimiento:', mantenimiento)
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-mantenimiento {
    padding: 20px;

    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }

    .mantenimiento-content {
        .el-card {
            margin-bottom: 20px;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);

            :deep(.el-card__header) {
                background-color: var(--color-surface-base);
                border-bottom: 1px solid var(--color-border);
                border-radius: var(--radius-md) var(--radius-md) 0 0;

                span {
                    color: var(--color-primary);
                    font-weight: 500;
                }
            }

            :deep(.el-table) {
                .el-table__header-wrapper {
                    .el-table__header {
                        th {
                            background-color: var(--color-surface-alt);
                            color: var(--color-primary);
                            font-weight: 500;
                        }
                    }
                }

                .el-table__body-wrapper {
                    .el-table__body {
                        td {
                            color: var(--color-surface-muted);
                        }
                    }
                }
            }

            :deep(.el-button--mini) {
                border-radius: var(--radius-sm);

                &.el-button--default {
                    border-color: var(--color-btn-primary);
                    color: var(--color-btn-primary);

                    &:hover {
                        background-color: var(--color-btn-primary);
                        color: #fff;
                    }
                }

                &.el-button--danger {
                    border-color: var(--color-btn-danger);
                    color: var(--color-btn-danger);

                    &:hover {
                        background-color: var(--color-btn-danger);
                        color: #fff;
                    }
                }
            }
        }
    }
}
</style>